import React from "react";

const CallEnded = () => {
  return (
    <div>Call ended</div>
  )
}

export default CallEnded;